import $ from 'jquery';
import './tab-toggle';
import './scroll';
import './woocommerce';
import './sliders';
import './cart';
import './size-guide';
import './language-switcher';
import './progress-ring';
import './gauge-animation';
import './hero-sticky';
import './bubbles';
import './product-slider-fade';



$(document).ready(function () {

	var btn = $('.n-toggle');
	
	btn.on('click', function () {
		$('.n-icon').toggleClass('active');
		$('.menu-mobile').toggleClass('show');
		$('body').toggleClass('mobile-menu-open');
	});

	if ($('body').hasClass('page-template-page-kickstarter')) {
		let vh = window.innerHeight * 0.01;
		// Then we set the value in the --vh custom property to the root of the document
		document.documentElement.style.setProperty('--vh', `${vh}px`);
		// We listen to the resize event
		window.addEventListener('resize', () => {
			// We execute the same script as before
			let vh = window.innerHeight * 0.01;
			document.documentElement.style.setProperty('--vh', `${vh}px`);
		});
	}

	$('footer.footer a').on('click', function (e) {
		if (e.target.href.includes('#')) {
			e.preventDefault();
		}
	});

	$('.menu-item-has-children .arrow, .menu-item-has-children > a').on('click', function(e) {
		e.preventDefault();
		$(this).parent().toggleClass('open-sub-menu')
		$('body').toggleClass('open-sub-menu')

	})

	$(document).on('click', '#close-prompt', function(e) {
		e.preventDefault()
		$(document).find('#prompt-discovery-pack').remove()
	})


	$(document).on('click', '.image-with-text .title-link h1, .image-with-text .title-link h2', function(e) {

		e.stopPropagation()

		if( window.innerWidth <= 768 ) {

			const header = $(e.target)
	
			const link = header.parent()
	
			link.attr('target', '_self')

		}

	})


	setTimeout(function () {
		$('.blur').each(function () {
			$(this).removeClass('blur');
		});
	}, 900);

	if (jsonImages !== 0) {
		(function () {
			if (jsonImages.length > 0) {
				var rotator = document.getElementById('rotator'), //get the element
					delayInSeconds = 1; //delay in seconds
				var i = 0;
				setInterval(function () {
					rotator.style.backgroundImage =
						"url('" + jsonImages[i] + "')";
					//rotator.src = jsonImages[i];
					i++;
					if (i === jsonImages.length) {
						i = 0;
					}
				}, delayInSeconds * 300);
			}
		})();
	}

});


document.addEventListener('DOMContentLoaded', () => {

	if (document.querySelector('.shop-banner.animate')) {

		const marquee = new Marquee('.shop-banner.animate .marquee', {
			speed: 1,
		});

	}

});


class Marquee {
    selector = '';
    parentSelector = null;
    clone = null;
    timeoutId = null;
    animationFrameId = null; // <--- NEW
    settings = {
        speed: 0.2
    };
    lastTime = 0;
    isPaused = false;
    currentMarginLeft = 0;
    wrapper = null; // <--- Save wrapper reference
    i = 0; // <--- Save scrolling state

    constructor(selector, settings = null) {
        this.selector = selector;

        if (settings && typeof settings === 'object') {
            this.settings = Object.assign(this.settings, settings);
        }

        this.run();

        this.reset = this.throttle(this.reset.bind(this), 300); // 300ms better for resize
        window.addEventListener('resize', this.reset);
    }

    run() {
        this.parentSelector = document.querySelector(this.selector);

        if (this.parentSelector === null) return;

        this.clone = this.parentSelector.innerHTML;

        this.wrapper = this.parentSelector.querySelector('.wrapper');
        if (!this.wrapper) return;

        const width = this.wrapper?.children?.length ? (Array.from(this.wrapper.children).reduce((sum, el) => sum + el.offsetWidth, 0) ?? 0) : 0;
        const windowWidth = window.innerWidth;
        const times = windowWidth / width;

        if (times > 0) {
            let x = Math.ceil(times);

            for (let counter = 0; counter < x; counter++) {
                this.parentSelector.insertAdjacentHTML('beforeend', this.clone);
            }
        }

        // Reset animation state
        this.wrapper.style.marginLeft = '0px';
        this.i = 0;
        this.lastTime = 0;

        this.parentSelector.addEventListener('mouseenter', this.pause.bind(this));
        this.parentSelector.addEventListener('mouseleave', this.resume.bind(this));

        // Start animation
        this.startAnimation();
    }

    startAnimation() {
        const animate = (time) => {
            if (this.lastTime === 0) this.lastTime = time;

            const deltaTime = time - this.lastTime;
            this.lastTime = time;

            if (!this.isPaused) {
                this.i += this.settings.speed * (deltaTime / 16);

                this.wrapper.style.marginLeft = `-${this.i}px`;

                if (this.i > this.wrapper.clientWidth) {
                    this.i = 0;
                }
            }

            this.animationFrameId = requestAnimationFrame(animate);
        };

        this.animationFrameId = requestAnimationFrame(animate);
    }

    pause() {
        this.isPaused = true;
    }

    resume() {
        this.isPaused = false;
    }

    reset() {
        // Cancel the previous animation frame
        if (this.animationFrameId) {
            cancelAnimationFrame(this.animationFrameId);
            this.animationFrameId = null;
        }

        // Clean up previous content
        this.parentSelector.innerHTML = '';

        this.parentSelector.insertAdjacentHTML('beforeend', this.clone);

        this.run();
    }

    throttle(func, delay) {
        return (...args) => {
            if (this.timeoutId === null) {
                func.apply(this, args);

                this.timeoutId = setTimeout(() => {
                    this.timeoutId = null;
                }, delay);
            }
        };
    }
}
